export default (theme) => ({
    errorContainer: {
        alignItems: 'center',
        backgroundColor: theme.colors.semantic.error050,
        border: `1px solid ${theme.colors.semantic.error200}`,
        borderRadius: 8,
        display: 'flex',
        gap: 12,
        padding: 16,
    },
    errorText: {
        color: theme.colors.semantic.error700,
        fontSize: 14,
        fontWeight: 500,
    },
    root: {
        alignItems: 'center',
        backgroundColor: theme.colors.background.utility025,
        borderRadius: 21,
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'nowrap',
        gap: 8,
        margin: '8px 0',
        padding: '0 16px',
        position: 'relative',
        maxWidth: '100%',
        '&, & *': {
            boxSizing: 'border-box',
        },
    },
    visualizerContainer: {
        display: 'flex',
        height: 42,
        padding: 0,
        maxWidth: '100%',
    },
});
